import { api } from '@/api/ApiGateway.js'

class ResourcesApi
{
	list(includeEmpty, onSuccess, onError) {
		api.get('resources', { 'includeEmpty': includeEmpty }).then(response => {
			if (response.hasError()) {
				response.showErrorBanner()
				onError(response)
				return
			}

			if (!response.body()?.data) {
				response.overrideError({ detail: 'Error getting resources.' })
				onError(response)
				return
			}

			onSuccess(response.body())
		})
	}

	createResource(resource, onSuccess, onError) {
		api.post('resource', resource).then(response => {
			if (response.hasError()) {
				response.showErrorBanner()
				onError(response)
				return
			}

			if (!response.body()?.data) {
				response.overrideError({ detail: 'Error creating resource.' })
				onError(response)
				return
			}

			onSuccess(response.body())
		})
	}

	updateResource(resource, onSuccess, onError) {
		api.patch('resource', resource).then(response => {
			if (response.hasError()) {
				response.showErrorBanner()
				onError(response)
				return
			}

			if (!response.body()?.data) {
				response.overrideError({ detail: 'Error updating resource.' })
				onError(response)
				return
			}

			onSuccess(response.body())
		})
	}

	deleteResource(resourceId, responseCallback) {
		api.delete(`resource/${resourceId}`).then(response => {
			responseCallback(response.response.data.success)
		})
	}

	createResourceCategory(category, onSuccess, onError) {
		api.post('resource-category', category).then(response => {
			if (response.hasError()) {
				response.showErrorBanner()
				onError(response)
				return
			}

			if (!response.body()?.data) {
				response.overrideError({ detail: 'Error creating resource category.' })
				onError(response)
				return
			}

			onSuccess(response.body())
		})
	}

	updateResourceCategory(resourceCategory, onSuccess, onError) {
		api.patch('resource-category', resourceCategory).then(response => {
			if (response.hasError()) {
				response.showErrorBanner()
				onError(response)
				return
			}

			if (!response.body()?.data) {
				response.overrideError({ detail: 'Error updating resource category.' })
				onError(response)
				return
			}

			onSuccess(response.body())
		})
	}

	deleteResourceCategory(resourceCategoryId, responseCallback) {
		api.delete(`resource-category/${resourceCategoryId}`).then(response => {
			responseCallback(response.response.data.success)
		})
	}

	createResourceSubcategory(subcategory, onSuccess, onError) {
		api.post('resource-subcategory', subcategory).then(response => {
			if (response.hasError()) {
				response.showErrorBanner()
				onError(response)
				return
			}

			if (!response.body()?.data) {
				response.overrideError({ detail: 'Error creating resource subcategory.' })
				onError(response)
				return
			}

			onSuccess(response.body())
		})
	}

	updateResourceSubcategory(resourceSubcategory, onSuccess, onError) {
		api.patch('resource-subcategory', resourceSubcategory).then(response => {
			if (response.hasError()) {
				response.showErrorBanner()
				onError(response)
				return
			}

			if (!response.body()?.data) {
				response.overrideError({ detail: 'Error updating resource subcategory.' })
				onError(response)
				return
			}

			onSuccess(response.body())
		})
	}

	deleteResourceSubcategory(resourceSubcategoryId, responseCallback) {
		api.delete(`resource-subcategory/${resourceSubcategoryId}`).then(response => {
			responseCallback(response.response.data.success)
		})
	}
}

export const resourcesApi = new ResourcesApi()